import React from 'react'
import { Typography } from '@material-ui/core'
import QuiltViewer from './QuiltViewer'
import quiltType from './quiltType'
import styles from './quilt.module.scss'
import Slider from '@material-ui/core/Slider'
import Stage from 'components/Designer/Stage'

const marks = [
  { value: 1, label: 'small' },
  { value: 8, label: 'large' },
]

const QuiltPreviewWrapper = ({
  selectedQuilt,
}: {
  selectedQuilt: quiltType | undefined
}) => {
  const stage = Stage.getInstance()
  const { name, path, stitchColor, color, scale, rotation } = selectedQuilt || {
    name: '',
    path: '',
    stitchColor: 'white',
    color: 'black',
  }

  return (
    <div className={styles.qPreviewWrapper}>
      <Typography>{selectedQuilt ? name : 'No Quilting selected.'}</Typography>
      {selectedQuilt ? (
        <div>
          <QuiltViewer
            path={path!}
            className={styles.quiltPreview}
            color={color}
            tint
            scale={200}
            stitch
            stitchColor={stitchColor}
          />
          <Slider
            value={(scale && scale[0]) || 1.5}
            min={1}
            max={8}
            // marks={marks}
            step={0.5}
            valueLabelDisplay="on"
            onChangeCommitted={(e, v) => {
              /* (stage.quilt = { scale: [v as number, v as number] }) */
            }}
          />
          <Slider
            value={rotation || 0}
            min={0}
            max={90}
            // marks={marks}
            step={15}
            valueLabelDisplay="on"
            onChangeCommitted={(e, v) => {
              /* (stage.quilt = { rotation: v as number }) */
            }}
          />
        </div>
      ) : (
        <div className={`${styles.quiltPreview} ${styles.blank}`} />
      )}
    </div>
  )
}
export default QuiltPreviewWrapper
